import jakartaLogo from '../assets/JakartaLogo.svg';
import baliLogo from '../assets/BaliLogo.svg';
import semarangLogo from '../assets/SemarangLogo.svg';

import bannerGmis from '../assets/Banner-GMIS Students.png';
import preschool from '../assets/PRESCHOOL.png';
import primarySchool from '../assets/PRIMARY SCHOOL.png';
import juniorSchool from '../assets/JUNIOR SCHOOL.png';
import seniorSchool from '../assets/SENIOR SCHOOL.png';
import whyIbCambridge from '../assets/WHY GMIS-IB,Cambridge.JPG';
import whyHolistic from '../assets/WHY GMIS - HOLISTIC.png';
import whyAcademic from '../assets/WHY GMIS-Academic Excellence.jpeg';

import bseisiLogo from '../assets/BSEISI.png';
import cambridgeLogo from '../assets/CAMBRIDGE.png';
import ibLogo from '../assets/IB CONTINUUM.png';
import tutlogo from '../assets/TUT WURI HANDAYANI.png';

import locJakarta from '../assets/GMIS JAKARTA.png';
import locBali from '../assets/GMIS BALI.png';
import locSemarang from '../assets/GMIS SEMARANG.png';


const u = (id, w) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const STAT_NUMS = ['1,000+', '25+', '100%', '30+', '75+'];

export const CURRENT_CAMPUS = 'jakarta';

export const LOCS = [
  {
    id: 'jakarta',
    name: 'GMIS Jakarta',
    region: 'Jakarta',
    domain: 'gmis.sch.id',
    url: 'https://gmis.sch.id',
    mapsUrl: 'https://www.google.com/maps/place/Gandhi+Memorial+Intercontinental+School/@-6.151295,106.8522851,17z/data=!4m15!1m8!3m7!1s0x2e68e6302427de59:0x9d6b41147608c1e9!2sGandhi+Memorial+Intercontinental+School!8m2!3d-6.1513217!4d106.8523549!10e5!16s%2Fm%2F02vs_lz!3m5!1s0x2e68e6302427de59:0x9d6b41147608c1e9!8m2!3d-6.1513217!4d106.8523549!16s%2Fm%2F02vs_lz',
    logo: jakartaLogo,
    image: locJakarta,
  },
  {
    id: 'bali',
    name: 'GMIS Bali',
    region: 'Bali',
    domain: 'gmisbali.sch.id',
    url: 'https://gmisbali.sch.id',
    mapsUrl: 'https://maps.google.com/?q=Gandhi+Memorial+Intercontinental+School+Bali',
    logo: baliLogo,
    image: locBali,
  },
  {
    id: 'semarang',
    name: 'GMIS Semarang',
    region: 'Semarang',
    domain: 'gmissemarang.sch.id',
    url: 'https://gmissemarang.sch.id',
    mapsUrl: 'https://maps.google.com/?q=Gandhi+Memorial+Intercontinental+School+Semarang',
    logo: semarangLogo,
    image: locSemarang,
  },
];

export const IMG = {
  hero: [
    bannerGmis,
    u('1759143101324-d375443f1955', 1800),
    u('1577896851231-70ef18881754', 1800),
  ],
  about: locJakarta,
  why: [
    whyIbCambridge,
    whyHolistic,
    whyAcademic,
  ],
  level: [
    preschool,
    primarySchool,
    juniorSchool,
    seniorSchool,
  ],
  loc: [
    locJakarta,
    locBali,
    locSemarang,
  ],
  accred: [
    ibLogo,
    cambridgeLogo,
    bseisiLogo,
    tutlogo,
  ],
};
